import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-950 px-4 text-center">
      <span className="text-5xl">🔥</span>
      <h1 className="mt-4 text-4xl font-bold text-neutral-100">404</h1>
      <p className="mt-2 text-neutral-400">This page doesn't exist.</p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center justify-center rounded-lg bg-ember-600 px-4 py-2 text-sm font-medium text-white hover:bg-ember-700 transition-colors"
      >
        Back to home
      </Link>
    </div>
  );
}
